import { LogoIcon } from 'shared/icons/LogoIcon'
import { ProfileIcon } from 'shared/icons/ProfileIcon'
import { LinkButton } from './LinkButton'
import styles from './Settings.module.css'
import { NotificationIcon } from 'shared/icons/NotificationIcon'
import { ApplicationPaths } from 'components/api-authorization/ApiAuthorizationConstants'
import { ShareButton } from './ShareButton'
import { LogoutIcon } from 'shared/icons/LogoutIcon'
import { AboutIcon } from 'shared/icons/AboutIcon'
import { HowToInstallIcon } from 'shared/icons/HowToInstallIcon'
import { useDynamicMainToolbar } from 'shared/hooks/useMainToolbar'
import { MainToolbarContent } from './MainToolbarContent'
import { Button } from './Button'
import { selectNotificationsSettingsDialogOpen, setNotificationsSettingsDialogOpen } from 'store/applicationSlice'
import { useAppDispatch, useAppSelector } from 'shared/hooks'

export const Settings = (): JSX.Element => {
    const dispatch = useAppDispatch()
    const notificationsSettingsDialogOpen = useAppSelector(selectNotificationsSettingsDialogOpen)

    const mainToolbarContent = (
        <MainToolbarContent />
    )

    useDynamicMainToolbar(mainToolbarContent, [])
    const handleNotificationButtonClick = () => {
        dispatch(setNotificationsSettingsDialogOpen(!notificationsSettingsDialogOpen))
    }

    return (
        <div className={styles.Settings}>
            <div>
                <LogoIcon className={styles.Settings__LogoIcon} />
            </div>
            <div className={styles.Settings__ListContainer}>
                <ul className={styles.Settings__List}>
                    <li>
                        <LinkButton
                            caption={'Profile'}
                            href={`${ApplicationPaths.Profile}`}
                            icon={<ProfileIcon className={styles.LinkButton__Icon} />}
                        />
                    </li>
                    <li>
                        <LinkButton
                            caption={'Notifications'}
                            href={'/notifications/settings'}
                            icon={<NotificationIcon className={styles.LinkButton__Icon} />}
                        />
                    </li>
                    <li>
                        <LinkButton
                            caption={'How to install'}
                            href={'/install/instruction'}
                            icon={<HowToInstallIcon className={styles.LinkButton__Icon} />}
                        />
                    </li>
                    <li>
                        <LinkButton
                            caption={'About'}
                            href={'/about'}
                            icon={<AboutIcon className={styles.LinkButton__Icon} />}
                        />
                    </li>
                    <li>
                        <LinkButton
                            caption={'Logout'}
                            href={`${ApplicationPaths.LogOut}`}
                            icon={<LogoutIcon className={styles.LinkButton__Icon} />}
                        />
                    </li>
                    <li>
                        <ShareButton />
                    </li>
                </ul>
            </div>
        </div>
    )
}